import React from "react";
import { FaGithubSquare } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";

import "./Projects.css";

const ProjectsCard = ({ projectdata }) => {
	return (
		<div className="col-md-4 project-card">
			<div className="card m-2 text-dark text-center">
				<img
					src={projectdata.img}
					className="card-img-top project-img"
					alt="..."
				/>
				<div className="card-body">
					<h5 className="card-title">{projectdata.name}</h5>
					<p className="card-text">{projectdata.description}</p>
					<p className="card-text">Technology Used: {projectdata.techused}</p>
					<div className="card-footer ">
						<a href={`${projectdata.livelink}`} target="__blank">
							<button className="btn btn-secondary mr-2">
                Live <FiExternalLink />
							</button>
						</a>
						<a href={`${projectdata.githublink}`} target="__blank">
							<button className="btn btn-secondary ">
                code
								<FaGithubSquare />
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProjectsCard;
